<script>
import names from "@/modules/survey/routers/names";
import {mapGetters} from "vuex";
import {displayDate, urlify} from "@/helper";

export default {
  name: "SurveyDetailTemplate",
  props: {
    survey: Object
  },
  computed: {
    names: () => names,
    ...mapGetters({
      isAuthenticate: 'auth/isAuthenticated'
    }),
  },
  methods: {
    urlify,
    displayDate: displayDate,
  }
}
</script>

<template>
  <v-sheet>
    <v-list-item>
      <v-list-item-icon>
        <v-icon>bookmark</v-icon>
      </v-list-item-icon>
      <v-list-item-title class="text-left">
        {{ survey.name }}
      </v-list-item-title>
    </v-list-item>
    <v-list-item>
      <v-list-item-icon>
        <v-icon>description</v-icon>
      </v-list-item-icon>
      <v-list-item-content class="text-left" v-html="urlify(survey.description)"></v-list-item-content>
    </v-list-item>
    <div v-show="!isAuthenticate">
      <div v-if="survey.kind !== '0'" >
        <v-alert outlined type="info"  v-if="(survey.anonymity === '0'||(survey.anonymity === '2' && anonym_status))">
          Важно! Для подтверждения статуса "Работник/Обучающийся" необходимо авторизоваться в системе.
          При этом сбор персональных данных (ФИО) не выполняется, результаты опроса будут полностью анонимны.
        </v-alert>
      </div>
    </div>
    <v-alert outlined type="info" v-if="(survey.anonymity === '2' && !anonym_status)">
      При выборе анонимного прохождения опроса сбор персональных данных (ФИО) не выполняется, результаты опроса будут полностью анонимны
    </v-alert>
    <v-list-item>
      <v-list-item-icon>
        <v-icon>visibility</v-icon>
      </v-list-item-icon>
      <v-list-item-content class="text-left" >
        <v-list-item-title v-if="survey.anonymity === '0'">Анонимно</v-list-item-title>
        <v-list-item-title v-if="survey.anonymity === '1'">Не анонимно</v-list-item-title>
        <v-list-item-title v-if="survey.anonymity === '2'">На выбор пользователя</v-list-item-title>
        <v-list-item-subtitle>Анонимность опроса</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-row class=" text-left">
      <v-col
        :cols="survey.anonymity === '2' ? 4 : 6"
      >
        <v-list-item>
          <v-list-item-icon>
            <v-icon>event</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ displayDate(survey.publication_date) }}</v-list-item-title>
            <v-list-item-subtitle>Дата начала</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col
        :cols="survey.anonymity === '2' ? 4 : 6"
      >
        <v-list-item>
          <v-list-item-icon>
            <v-icon>event_available</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{displayDate( survey.end_date) }}</v-list-item-title>
            <v-list-item-subtitle>Дата окончания</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col
        v-if="survey.anonymity === '2'"
        cols="4"
      >
        <v-checkbox
          v-model="anonym_status"
          label="Анонимный опрос"
        ></v-checkbox>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<style scoped>

</style>
